module.exports = __webpack_public_path__ + "img/24.136e9f9f.png";